import { configureStore, ThunkAction } from '@reduxjs/toolkit';

import { ChatStickyParams } from '../types/initial-config';
import { chatSession } from '../utils/session';
import { chatSessionIsActive } from './selectors';
import brukerReducer from './slices/bruker';
import chatStateReducer from './slices/chat-state';
import chatWindowReducer from './slices/chat-window';
import configReducer from './slices/config';
import topicSelectionReducer from './slices/topic-selection';

export const store = configureStore({
  reducer: {
    chatState: chatStateReducer,
    chatWindow: chatWindowReducer,
    config: configReducer,
    bruker: brukerReducer,
    topicSelection: topicSelectionReducer,
    texts: (): ChatStickyParams => window.ChatStickyParams ?? {}
  },
  preloadedState: chatSession.getSavedState()
});

store.subscribe(() => {
  const state: RootState = store.getState();
  if (chatSessionIsActive(state) && !chatSession.hasSavedState()) {
    chatSession.saveState(state.topicSelection);
  }
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk<R = void> = ThunkAction<
  R,
  RootState,
  void,
  { type: unknown }
>;
